import { Image, Link } from '@com-delta-idp/mnx-ui-kit';
import { GenericLabel } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import * as uuid from 'uuid';
import { getErrorMessage } from '../adapters/error.adapter';
import { DisplayProperties, TYPE } from '../models';
import { AEMErrorMessage } from '../models/aem/error-message.interface';

export const getEmptyContent = <T extends DisplayProperties>(
  error = '',
  aemErrorMessages?: AEMErrorMessage[],
  loaded = false,
  disabled = true
): T => {
  const empty: T = {} as T;
  empty.disabled = disabled;
  empty.loaded = loaded;
  empty.error = getErrorMessage(error, aemErrorMessages);
  return empty;
};

export const getImage = (src: string, alt: string): Image => {
  return { src, alt: alt + ' ' + 'image' };
};

export const getGenericLabel = (
  title: string,
  subtitle: string
): GenericLabel => {
  return { title, subtitle };
};

export const getLink = (label: string, url: string): Link => {
  return { label, url };
};

export const getLinkWithId = (label: string, url: string, id: string): Link => {
  return { label, url, id };
};

// To check whether the property is defined
export const checkDefined = (property: string | undefined): string => {
  return property ?? '';
};

// To get random number within specified range
export const getRandomNumber = (min: number, max: number): number => {
  return Math.floor(Math.random() * max + min);
};

export const checkErrors = (
  errors: (string | undefined)[],
  aemErrorMessages: AEMErrorMessage[] | undefined
) => {
  return (
    errors.filter((error) => error !== undefined).length && aemErrorMessages
  );
};

export const getUniqueIdentifier = (): string => {
  return uuid.v4();
};

export const formatDate = (date: string): string => {
  return new Date(date + 'T12:00:00Z').toLocaleDateString(TYPE.LOCALE, {
    year: TYPE.OPTIONS_YEAR_DAY,
    month: TYPE.OPTIONS_MONTH,
    day: TYPE.OPTIONS_YEAR_DAY
  });
};

export const formatNumericDate = (date: string | undefined): string => {
  return new Date(date + 'T12:00:00Z').toLocaleDateString(TYPE.LOCALE, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
};

export const formatLongMonthDate = (date: string | undefined) => {
  return new Date(date + 'T12:00:00Z').toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const decimalSeparator = (value: number): string => {
  const usFormatter = new Intl.NumberFormat(TYPE.LOCALE);
  return usFormatter.format(value);
};

export const getLoginMethod = (): string => {
  return (
    JSON.parse(localStorage.getItem('qm_login_method') ?? '{}')?.value || ''
  );
};

export const getCobrandList = (cobrandList: string) => {
  return cobrandList
    ? cobrandList
        .split(':')
        .map((item) => item.trim().toLowerCase())
        .join(',')
    : '';
};
